(function () {
    let institutionAffiliations = {
        $target: null,
        $section: $('.section'),
        $removeBtn: $('.remove_button'),
        $statusMsg: $('.statusMsg'),
        selectors: {
            remoteInstitutionalAccess: '.remote_institutional_access',
            removeBtn: '.remove_button',
            section: '.section',
        },

        init: function () {
            institutionAffiliations.$target = $('.ajaxCall');

            this.widget = document.querySelector(this.selectors.remoteInstitutionalAccess);
            this.RemoveURL = '/action/deleteInstitutionalAffiliation';
            institutionAffiliations.control();
        },
        control: function () {
            institutionAffiliations.$target.on('click', function (e) {
                e.preventDefault();
                institutionAffiliations.update(e.target);
            });

            this.removeButtons = this.widget.querySelectorAll(this.selectors.removeBtn);
            $(this.removeButtons).on('click', institutionAffiliations.onRemoveButtonClick.bind(this));
        },
        update: function (target) {
            $(target).attr('disabled', 'disabled');
            $.ajax({
                method: 'GET',
                url: $(target).data('url'),
                success: function (data) {
                    var json = JSON.parse(data);
                    if (json.message) {
                        institutionAffiliations.displaySuccessMessage(target, json);
                    }
                    $(target).removeAttr('disabled');
                },
                error: function () {
                    institutionAffiliations.displayErrorMessage(target);
                    $(target).removeAttr('disabled');
                },
            });
        },
        displaySuccessMessage: function (target, data) {
            $(target).parent('.renew_part').find('.renew_verification_message').html(data.message);
        },
        displayErrorMessage: function (target) {},
        onRemoveButtonClick(e) {
            const target = e.currentTarget;
            const uuid = target.dataset.uuid;
            const type = target.dataset.type;
            const element = target.closest(this.selectors.section);

            $.ajax({
                //url: '/specs/products/achs/widgets/institutional-affiliations/templates/data/successMsg.json', //for testing
                //type: 'GET', //for testing
                url: this.RemoveURL,
                type: 'POST',
                data: {
                    institutionUuid: uuid,
                    affiliationType: type,
                },
                success: function (response) {
                    if (response) {
                        institutionAffiliations.$statusMsg.css({display: 'block'});
                        institutionAffiliations.$statusMsg.addClass('success-msg');
                        institutionAffiliations.$statusMsg.text(response.message);
                        element.remove();
                    }

                    location.reload();
                },
                error: function (jqHXR, status, error) {
                    institutionAffiliations.$statusMsg.css({display: 'block'});
                    institutionAffiliations.$statusMsg.addClass('error-msg');
                    institutionAffiliations.$statusMsg.text('Institutional Affiliation has not been Deleted');
                },
            });
        },
    };

    UX.institutionAffiliations = institutionAffiliations;
})();
